import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="scroll-to-top-button"
      aria-label="Torna su"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-charcoal/90 text-ivory shadow-[0_8px_20px_rgba(37,37,37,0.25)] backdrop-blur transition-all duration-300 hover:bg-charcoal hover:scale-105 active:scale-95"
    >
      <ArrowUp className="h-5 w-5" strokeWidth={2} />
    </button>
  );
}
